export const SEARCH = "Search Flights";
export const MISSING_INFO_SEARCH_ERROR =
  "To continue, please complete all required fields.";
export const MULTICITY_CALENDAR_HEADER_TITLE = "Select the outbound date for your flight from"
export const MAX_NUM_MULTICITY_ROUTES = 5;
